import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled, type SxProps, type Theme } from '@mui/material/styles';
import Link from 'next/link';
import clsx from 'clsx';
import ForgenticMark from './ForgenticMark';

type Props = {
  className?: string | string[];
  logoClass?: string | string[];
  placement?: 'left' | 'center' | 'right';
  sx?: SxProps<Theme>;
};

const ForgenticBranding = ({ className, logoClass, sx }: Props) => {
  const BoxStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: theme.palette.text.primary,
  }));

  return (
    <Link href="/" className={clsx(className)} style={{ textDecoration: 'none' }}>
      <BoxStyled sx={sx}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 64 }}>
          <ForgenticMark sx={{ width: 38 }} className={logoClass} />
        </Box>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.7rem',
            lineHeight: '0.40rem',
            opacity: 0.5,
          }}
        >
          {process.env.APP_VERSION}
        </Typography>
      </BoxStyled>
    </Link>
  );
};

export default ForgenticBranding;
